// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__Ql6Df","messages":"Chat_messages__1lOC8","dateDivider":"Chat_dateDivider__1U0ic"};